/** Normalize axios/network failures so HTML 502 pages are never treated as objects. */
export function httpErrorPayload(error, fallback = "Network error") {
  const status = error?.response?.status;
  const data = error?.response?.data;
  const payload =
    data && typeof data === "object" && !Array.isArray(data)
      ? { ...data }
      : { status: "error", message: fallback };
  const rawMessage = String(payload.message || "");
  if (!rawMessage.trim() || /<\s*html/i.test(rawMessage)) {
    payload.message =
      status === 502 || status === 503 || status === 504
        ? fallback
        : error?.message || fallback;
  }
  if (status) payload.statusCode = status;
  return payload;
}
